const MODAL_ID = 'massCommDiscardModal';
const DISCARD_MESSAGE = 'You have unsaved changes. Leave and discard them?';
let dirty = false;
let pendingConfirm = null;

export function markMassCommDirty() {
    dirty = true;
}

export function markMassCommClean() {
    dirty = false;
}

export function massCommHasUnsavedChanges() {
    return dirty;
}

function modalEl() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) {
        throw new Error('mass-comm-unsaved-guard: missing massCommDiscardModal');
    }
    return modal;
}

export function confirmDiscardMassCommChanges(onConfirm) {
    if (typeof onConfirm !== 'function') {
        throw new Error('mass-comm-unsaved-guard: onConfirm callback is required');
    }
    if (!dirty) {
        onConfirm();
        return;
    }
    pendingConfirm = onConfirm;
    $(modalEl()).modal('show');
}

export function confirmDiscardMassCommChangesNative(onConfirm, onCancel) {
    if (typeof onConfirm !== 'function') {
        throw new Error('mass-comm-unsaved-guard: onConfirm callback is required');
    }
    if (!dirty || window.confirm(DISCARD_MESSAGE)) {
        onConfirm();
    } else if (typeof onCancel === 'function') {
        onCancel();
    }
}

export function bindMassCommDiscardModal($) {
    const modal = modalEl();
    $(modal)
        .off('click.massCommDiscard', '#massCommDiscardConfirm')
        .on('click.massCommDiscard', '#massCommDiscardConfirm', function () {
            const confirmed = pendingConfirm;
            pendingConfirm = null;
            $(modal).modal('hide');
            if (confirmed) {
                confirmed();
            }
        });
    $(modal)
        .off('hidden.bs.modal.massCommDiscard')
        .on('hidden.bs.modal.massCommDiscard', function () {
            pendingConfirm = null;
        });
}

export function bindMassCommUnsavedTracking($) {
    const selector = '#email_subject_entry, #email_body_entry, #sms_entry';
    $(document)
        .off('input.massCommUnsaved', selector)
        .on('input.massCommUnsaved', selector, markMassCommDirty);

    $(window)
        .off('beforeunload.massCommUnsaved')
        .on('beforeunload.massCommUnsaved', function (e) {
            if (!dirty) {
                return;
            }
            e.preventDefault();
            e.returnValue = '';
        });
}
